// TODO: remove this when "falcor-ise" is done

const falcor = require('falcor-json-graph');
const { set } = require('@dbk-legacy/muster/utils');

function toJsonGraph(pathValuePairs) {
  const graph = {};
  pathValuePairs.forEach(({ path, value }) => {
    set(graph, ['jsonGraph', ...path], value);
  });
  return graph;
}

function atom() {
  return falcor.atom();
}

function ref(path) {
  return falcor.ref(path);
}

function error(message) {
  return falcor.error(message);
}

module.exports = {
  toJsonGraph,
  atom,
  ref,
  error,
};
